<template>
    <div>
        <van-tabs @click="changeActive" v-model="active" class="tabs_header">
            <template #nav-left>
                <van-icon @click="onClickLeft" name="arrow-left" /></template>
            <van-tab title="我的草稿"></van-tab>
            <van-tab title="我的帖子"></van-tab>
        </van-tabs>

        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div class="tab_box" v-if="active == 0">
                <div class="total">我的草稿（{{ total1 }}）</div>
                <draft-scroll :url="'my/rough-list'" @on-fetch="onFetch" ref="roughList">
                    <template slot-scope="scope">
                        <div v-for="(row,i) in scope.data" :key="i" class="tb_item">
                            <div class="left">
                                <div class="tit">
                                    <span class="tag" v-if="row.tag_name">{{ row.tag_name }}</span>
                                    <span class="title">
                                        {{ row.title }}
                                    </span>
                                </div>
                                <div class="cont" v-html="row.content"></div>
                            </div>
                            <div class="right">
                                <div class="oprs"
                                    @click="doEdit(row.id,row.title,row.game_id,row.tag_id,row.content,row.attachments,row.videos,row.discuss)">
                                    <img src="../../assets/icons/modify.png" alt="">
                                </div>
                                <div class="oprs" @click="doDel(row.id)">
                                    <img src="../../assets/icons/delete.png" alt="">
                                </div>
                            </div>
                        </div>
                    </template>
                </draft-scroll>
            </div>

            <div class="tab_box" v-else>
                <div class="total">我的帖子（{{ total2 }}）</div>
                <topic-scroll :url="'topic/user-topic-list'"
                    :params="{user_id: this.$store.getters.state.userData.userId,sort: 'date'}" :text2="'暂无帖子哦~'"
                    @on-fetch="onFetch2" v-if="this.$store.getters.state.userData">
                    <template slot-scope="scope">
                        <div v-for="(row,i) in scope.data" :key="i" class="topic_item" @click="gotoTopic(row.id)">
                            <div class="tit">{{ row.title }}</div>
                            <div class="time">{{ row.create_time }}</div>
                            <div class="cont">{{ row.desc.slice(0,70) }} {{ row.desc.length >= 70?'...':'' }}
                                <span class="qw">{{ row.desc.length >= 70?'全文':'' }}</span></div>
                            <div class="tag_icons">
                                <div class="tag">{{ row.game_name }}</div>
                                <div class="icons">
                                    <Button key="comment" size="small" type="text">
                                        <div class="button">
                                            <img class="comment_img" src="../../assets/icons/comment.png" alt="">
                                            <span>{{ Number(row.comment) > 10000 ? (Number(row.comment)/10000).toFixed(1) + 'w': Number(row.comment) }}</span>
                                        </div>
                                    </Button>
                                    <Button key="unlike" size="small" type="text">
                                        <div class="button">
                                            <img class="comment_img" src="../../assets/icons/unlike.png" alt="">
                                            <span>{{ Number(row.dislike) > 10000 ? (Number(row.dislike)/10000).toFixed(1) + 'w': Number(row.dislike) }}</span>
                                        </div>
                                    </Button>
                                    <Button key="like" size="small" type="text">
                                        <div class="button">
                                            <img class="comment_img" src="../../assets/icons/like.png" alt="">
                                            <span>{{ Number(row.like) > 10000 ? (Number(row.like)/10000).toFixed(1) + 'w': Number(row.like) }}</span>
                                        </div>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </template>
                </topic-scroll>
            </div>
        </van-pull-refresh>


    </div>
</template>

<script>
    import {
        Dialog
    } from "vant";
    import api from '../Api'
    export default {
        mixins: [api],
        data() {
            return {
                active: 0,
                total1: 0,
                total2: 0
            }
        },
        computed: {

        },
        mounted() {
            this.$store.dispatch("getUserData", true);
        },
        methods: {
            changeActive(name) {
                this.active = name
            },
            onFetch(data) {
                this.total1 = data.total
            },
            onFetch2(data) {
                this.total2 = data.total
            },
            gotoTopic(id) {
                this.$router.push({
                    name: 'topic.detail',
                    params: {
                        topicId: id
                    }
                })
            },
            //修改草稿
            doEdit(id, title, game_id, tag_id, content, attachments, videos, discuss) {
                var that = this
                this.$RModal.topic({
                    title: '编辑帖子',
                    selection: {
                        id,
                        title,
                        game_id,
                        tag_id,
                        content,
                        attachments,
                        videos,
                        discuss
                    },
                    onSuccess: () => {
                        that.$refs.roughList.refresh()
                    }
                })
            },
            //删除草稿
            doDel(topicId) {
                var that = this
                Dialog.confirm({
                        message: '您确定要删除该草稿吗？',
                    })
                    .then(() => {
                        that.$Ajax('my/remove-topic', {
                            topicId
                        }).then(rs => {
                            if (rs.code == 200) {
                                that.$refs.roughList.refresh()
                            }
                        })
                    })
                    .catch(() => {
                        // on cancel
                    });
            }
        },
    }
</script>

<style lang="less" scoped>
    .tab_box {
        margin-top: 2.5rem;
        padding: 1rem .75rem;

        .total {
            color: #656565;
            font-size: .6rem;
            margin-bottom: .6rem;
        }
    }

    .tb_item {
        background-color: #fff;
        border-radius: .7rem;
        padding: .7rem .6rem;
        margin-bottom: .6rem;
        display: flex;
        align-items: center;

        .left {
            flex: 1;

            .tit {
                display: flex;
                align-items: center;
                margin-bottom: .6rem;

                .tag {
                    width: 2.1rem;
                    height: 1rem;
                    line-height: 1rem;
                    text-align: center;
                    background-color: #670000;
                    border-radius: .2rem;
                    font-size: .6rem;
                    color: #fff;
                    margin-right: .3rem;
                }

                .title {
                    flex: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    color: #000;
                    font-size: 14px;
                    font-weight: 700;
                }
            }

            .cont {
                word-break: break-all;
                font-size: .6rem;
                color: #9e9e9e;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                transform: scale(0.95);
                transform-origin: 0 center;
                width: 10rem;
            }
        }

        .right {
            width: 4.8rem;
            margin-left: 1rem;
            display: flex;
            align-items: center;

            .oprs {
                width: 1.8rem;
                height: 1.8rem;
                background-color: #f3f2f2;
                border-radius: 50%;
                margin-right: .75rem;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    width: .75rem;
                    height: .7rem;
                }
            }
        }
    }

    .topic_item {
        padding: .45rem .6rem .6rem;
        background-color: #fff;
        border-radius: .7rem;
        margin-bottom: .6rem;

        .tit {
            color: #000;
            font-weight: 700;
        }

        .time {
            color: #9e9e9e;
            font-size: .6rem;
            transform: scale(0.85);
            transform-origin: 0 0;
            margin-bottom: 0.3rem;
        }

        .cont {
            color: #9e9e9e;
            font-size: .6rem;
            margin-bottom: .6rem;

            .qw {
                color: #670000;
            }
        }

        .tag_icons {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .tag {
                width: 4.3rem;
                height: 1.05rem;
                line-height: 1.05rem;
                background-color: #e4e4e4;
                border-radius: .3rem;
                font-size: .6rem;
                padding: 0 .95rem 0 .45rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                position: relative;

                &::after {
                    content: '';
                    position: absolute;
                    right: .35rem;
                    top: .3rem;
                    width: 0;
                    height: 0;
                    border-style: solid;
                    border-width: .2rem 0 .2rem .25rem;
                    border-color: transparent transparent transparent #656565;
                }
            }

            .icons {
                .ivu-btn {
                    color: #9e9e9e;
                    font-size: .6rem;

                    .button {
                        display: flex;
                        align-items: center;

                        .comment_img {
                            width: .75rem;
                            height: .7rem;
                            margin-right: .1rem;
                        }
                    }

                    &:hover,
                    &:active,
                    &:focus,
                    &.active {
                        background-color: transparent;
                        border-color: transparent;
                        color: #656565;
                        box-shadow: unset;
                    }
                }
            }
        }
    }
</style>